import styled, { css } from 'styled-components'
import React from 'react'
import { hexToRGBA } from '../../modules/utils/color'
import { IconButton as BaseIconButton } from '@material-ui/core'

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  float: left;
  width: 100%;
`

export const Wrapper = styled.div`
  align-items: center;
  display: flex;

  > * {
    margin-left: 10px;
  }
`

export const TextWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`

export const Dates = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`

export const IconButton = styled(({ dayInCurrentMonth, currmonthbetween, dayIsBetween, futureDisable, ...props }) => (
  <BaseIconButton {...props} />
))`
  width: 36px;
  height: 36px;
  font-size: 15px;
  font-family: ${props => props.theme.typography.fontFamily};
  margin: 0 2px;
  color: ${props => (props.dayIsBetween ? props.theme.palette.brand.white : props.theme.palette.brand.gray[20])};

  ${props =>
    (props.dayInCurrentMonth || props.futureDisable) &&
    css`
      color: ${props => hexToRGBA(props.theme.palette.brand.gray[50], 0.5)};
    `}

  ${props =>
    props.currmonthbetween &&
    css`
      color: #676767;
    `}
`

export const Highlight = styled.div`
  background: ${props => (props.dayIsBetween ? props.theme.palette.brand.primary[50] : '')};
  color: ${props => (props.dayIsBetween ? props.theme.palette.brand.white : '')};

  border-top-left-radius: ${props => (props.isFirstDay ? '50%' : '0%')};
  border-bottom-left-radius: ${props => (props.isFirstDay ? '50%' : '0%')};

  border-top-right-radius: ${props => (props.isLastDay ? '50%' : '0%')};
  border-bottom-right-radius: ${props => (props.isLastDay ? '50%' : '0%')};
`
